import _ from 'lodash'
import { ENTRIES_LOADED } from '../constants';

const initialState = {byContentfulId: {}, all:[]};

export default function update(state = initialState, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.photos) {
                const result = initialState;
                Object.keys(action.entries.photos).map(key => {
                    result.byContentfulId[key] = action.entries.photos[key];
                    result.all.push(action.entries.photos[key]);
                })
                return result
            }
            break;
    }
    return state;
}
